import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UserLayout from '@components/layout/UserLayout.tsx';
import ScheduledOrdersList from '@features/client/scheduled-orders/ScheduledOrdersList.tsx';
import { ScheduledOrderStatus } from '@api/generated/search-service';
import { PermissionTypesEnum } from '@mock/Permissions.ts';
import { OrganizationFeatureEnum } from '@mock/OrganizationFeatures.ts';

const scheduledOrderSearchSchema = z.object({
  query: z.string().optional(),
  status: z.nativeEnum(ScheduledOrderStatus).optional(),
  supplierId: z.coerce.number().optional(),
  page: z.coerce.number().optional().default(1),
});

export type ScheduledOrderSearchParams = z.infer<typeof scheduledOrderSearchSchema>;

export const Route = createFileRoute('/c/$orgId/$portalId/scheduled-orders/')({
  validateSearch: search => scheduledOrderSearchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();

  return (
    <UserLayout
      oneOfPermission={[PermissionTypesEnum.CLIENT_SCHEDULED_ORDER_READ]}
      requiredFeature={OrganizationFeatureEnum.SCHEDULED_ORDERS}
    >
      <div className="max-w-[1200px] mx-auto">
        <ScheduledOrdersList search={search} />
      </div>
    </UserLayout>
  );
}
